"use client";

import { motion } from "framer-motion";

export const BackgroundGlow = () => (
  <>
    {/* Top-right glow */}
    <motion.div
      className="absolute top-0 right-0 w-[800px] h-[800px] bg-[rgb(var(--color-neon-blue)_/_0.4)] rounded-full blur-[120px] -translate-y-1/4"
      animate={{
        scale: [1, 1.1, 1],
        opacity: [0.4, 0.5, 0.4],
        x: [0, 20, 0],
        y: [-100, -80, -100],
      }}
      transition={{
        duration: 8,
        repeat: Infinity,
        ease: "easeInOut",
      }}
    />

    {/* Bottom-left glow */}
    <motion.div
      className="absolute bottom-0 left-0 w-[700px] h-[700px] bg-[rgb(var(--color-electric-blue)_/_0.4)] rounded-full blur-[120px] translate-y-1/4"
      animate={{
        scale: [1, 1.15, 1],
        opacity: [0.4, 0.5, 0.4],
        x: [0, -30, 0],
        y: [100, 80, 100],
      }}
      transition={{
        duration: 10,
        repeat: Infinity,
        ease: "easeInOut",
      }}
    />

    {/* Center glow */}
    <motion.div
      className="absolute top-1/2 right-1/4 w-[600px] h-[600px] bg-[rgb(var(--color-neon-green)_/_0.3)] rounded-full blur-[120px] -translate-y-1/2"
      animate={{
        scale: [1, 1.2, 1],
        opacity: [0.3, 0.4, 0.3],
        x: [0, 40, 0],
      }}
      transition={{
        duration: 12,
        repeat: Infinity,
        ease: "easeInOut",
      }}
    />
  </>
);
